export const contactsData = {
    email: 'nt@themarketingguy.dk',
    phone: '60146017',
    address: 'Menlo Park, California, United States - 673822 ',

    sheetAPI: ''
}